import Vue from 'vue'
import configs from '@/config'

let resource = null
const serviceTokensApiPath = `${configs.baseUrl}/api/admin/service-tokens`

const actions = {
  mintToken: {
    method: 'POST',
    url: `${serviceTokensApiPath}`,
  },
  revokeAllTokens: {
    method: 'POST',
    url: `${serviceTokensApiPath}/revoke`,
  },
}

const initResource = () => {
  resource = Vue.resource('', {}, actions)
}

// response schema: { token, expiresAt, label }
const mintToken = async (params) => {
  const res = await resource.mintToken(params)
  return res.body
}

// response schema: { ok: true }
const revokeAllTokens = async () => {
  const res = await resource.revokeAllTokens({})
  return res.body
}

export default {
  initResource,
  mintToken,
  revokeAllTokens,
}
